"use client"

import Script from "next/script"
import { GTM_CONSENT_DEFAULT_SCRIPT } from "@/lib/gtm/consent-mode-snippet"

function getGtmId(): string | undefined {
  const id = process.env.NEXT_PUBLIC_GTM_ID?.trim()
  return id || undefined
}

export function GoogleTagManagerScript() {
  if (process.env.NEXT_PUBLIC_ASTRA_SIGNUP_E2E === "1") return null
  const gtmId = getGtmId()
  if (!gtmId) return null

  return (
    <>
      <Script
        id="google-tag-manager-consent"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{ __html: GTM_CONSENT_DEFAULT_SCRIPT }}
      />
      <Script
        id="google-tag-manager"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`,
        }}
      />
    </>
  )
}

export function GoogleTagManagerNoScript() {
  if (process.env.NEXT_PUBLIC_ASTRA_SIGNUP_E2E === "1") return null
  const gtmId = getGtmId()
  if (!gtmId) return null

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmId)}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
      />
    </noscript>
  )
}
